module.exports = [
  // All versions before the last Browser Working Group review (Q3 2024)
  'last 999 major versions' +
    ' and not since 2024-10-09' +
    // _except_
    // the latest 2 versions of a browser
    ' and not last 2 versions' +
    // an unreleased version of a browser
    ' and not unreleased versions' +
    // and not browser versions after which cumulatively represent either >1%
    // of sessions or >1% of revenue
    ' and not safari >= 14' +
    ' and not ios >= 14' +
    ' and not chrome >= 106' +
    ' and not edge >= 126' +
    ' and not samsung >= 25' +
    ' and not firefox >= 128' +
    // and also not Firefox Extended Support Release
    ' and not firefox esr',

  // unless it is Internet Explorer
  'ie <= 11',

  // or a dead browser
  'dead',
];
